import { render, staticRenderFns } from "./CommLog.vue?vue&type=template&id=49423f68&"
import script from "./CommLog.vue?vue&type=script&lang=js&"
export * from "./CommLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports